export function addRemoveSlugFromAreaHolder( slug, selectedAreaHolder )
{
	var index = $.inArray(slug, selectedAreaHolder );
	
	if( index === -1 )
	{
		selectedAreaHolder.push(slug);
	}
	else
	{
		selectedAreaHolder.splice( index, 1 );
	}
	
	return selectedAreaHolder;
}
